import { Checkbox, TextArea } from '@lbcamden/lib-react';
import { FunctionComponent, ReactNode } from 'react';

import { CheckboxContainer } from './ConditionalCheckboxGroup.styled';

type Props = {
  id: string;
  label: ReactNode;
  value: string[];
  disabled?: boolean;
  errorOnEmpty?: boolean;
  onChange(value: false | string[]): void;
};

const getCustomOptionValue = (id: string, inputValue: string) => `${id}:${inputValue}`;

const getCustomOptionInputValue = (id: string, optValue: string) => optValue.replace(`${id}:`, '');

const getOtherOptionArrayIndex = (id: string, value: string[]) =>
  value.findIndex((optValue) => optValue.startsWith(id));

export const CustomOption: FunctionComponent<Props> = ({
  id,
  label,
  value,
  disabled,
  errorOnEmpty,
  onChange,
}) => {
  const customOptionArrayIndex = getOtherOptionArrayIndex(id, value);
  const customOptionSelected = customOptionArrayIndex >= 0;
  const customOptionInputValue = customOptionSelected
    ? getCustomOptionInputValue(id, value[customOptionArrayIndex])
    : '';

  const onOptionSelected = () => {
    const isSelected = !customOptionSelected;

    if (isSelected) {
      onChange([...value, getCustomOptionValue(id, '')]);
    } else {
      onChange(value.toSpliced(customOptionArrayIndex, 1));
    }
  };

  const onOptionValueChange = (newOptValue: string) =>
    onChange(value.toSpliced(customOptionArrayIndex, 1, getCustomOptionValue(id, newOptValue)));

  return (
    <>
      <CheckboxContainer>
        <Checkbox
          id={id}
          checked={customOptionSelected}
          disabled={disabled}
          onChange={onOptionSelected}
        />
        <label htmlFor={id}>{label}</label>
      </CheckboxContainer>
      {customOptionSelected && (
        <TextArea
          $error={errorOnEmpty && !customOptionInputValue}
          value={customOptionInputValue}
          onChange={(e) => onOptionValueChange(e.target.value)}
        />
      )}
    </>
  );
};
